import React from "react";
import {FontAwesomeIcon} from '@fortawesome/react-fontawesome';
import {faTimesCircle} from '@fortawesome/pro-light-svg-icons/faTimesCircle';

export default function FilterListHeader({title, showClearFilters, onClearFiltersClicked, clearAllText}) {
    return <div
        className="text-uppercase line-height-5 d-flex justify-content-between align-items-center flex-shrink-0">
        <span>{title}</span>
        {showClearFilters && <div
            className="text-gray-medium text-hover-gray font-size-0-625 line-height-4 h-30 d-flex align-items-center cursor-pointer"
            onClick={onClearFiltersClicked}>
            <span>{clearAllText}</span>
            <FontAwesomeIcon icon={faTimesCircle} className="pl-1 font-size-1-125" />
        </div>}
    </div>
}